import axios from 'axios'
import config from 'config'

const {
  quipper_api_host: api,
  video_payment_api_host: video,
  blog_api_host: blog,
} = config

// axios defaults properties
axios.defaults.baseURL = ''
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'

// DISABLE TEMPORARY SINCE cause a BUG for all ajax catch failed methods
// axios.interceptors.response.use(null, (error) => {
//   // Handle low level network errors, related with external services
//   // Real errors are hidden from us by the browser for fail network or offline
//   if (
//     error.message === 'Network Error' && // if network is error
//     error.code !== 'ECONNABORTED' &&  // if make sure this is not aborted request, eg from autocomplete
//     (error.config.url.includes(api) || error.config.url.includes(video)) // only for external request (api/video)
//   ) {
//     window.location = '/error/503'
//   }
// })

export { axios }
export default class API {
  static get(path, params = {}, options = {}) {
    return axios.get(path, { params, ...options })
  }

  static post(path, data = {}, options = {}) {
    return axios.post(path, data, { ...options })
  }

  static put(path, data = {}, options = {}) {
    return axios.put(path, data, { ...options })
  }

  static delete(path) {
    return axios.delete(path)
  }

  static endPoints(options = {}) {
    return (
      {
        auth: {
          logout: '/twirp/auth.Auth/Logout',
          register: `${api}/v1/users`,
          login: `${api}/qlearn/v1/authorizations`,
          facebook: `${api}/v1/authorizations/facebook`,
          application: `${video}/api/v1/users`,
          vp_meta: '/profile/set_vp_meta',
          onboarding_tooltip: `/profile/tooltip/add/${options.type}`,
        },
        aptitude: {
          calculate_answer: '/aptitude_test/calculate_answer',
          email_report: `/aptitude_test/send_report_via_email/${options.reportId}`,
          recommendation: '/aptitude_test/recommendation',
        },
        password: {
          generate_reset_password_token: '/generate_reset_password_token',
          reset_password: `${api}/qlearn/v1/user/reset_password`,
        },
        schools: {
          provinces: `${api}/qlearn/v1/schools/provinces`,
          cities: `${api}/qlearn/v1/schools/cities`,
          select: `${api}/qlearn/v1/schools/search`,
          search: '/search/schools',
          grades: `${api}/v1/grades`,
        },
        leads: {
          update: `/directory/${options.id}/leads`,
          partner: `/directory/${options.id}/partner_leads`,
        },
        common: {
          term_agreement: '/terms/agree',
          like: '/like',
          likesAutoComplete: `/likes/${options.kind}`,
        },
        search: {
          autocomplete: '/search/autocomplete',
          found: '/search/found',
          not_found: '/search/not_found',
        },
        profile: {
          current: `${video}/api/v1/users/current`,
          updateApi: `${api}/v1/user`,
          updateVideo: `${video}/api/v1/users`,
        },
        articles: `${blog}/wp-json/wp/v2/posts`,
        majors: '/majors',
        careers: '/careers',
        scholarship: '/scholarships',
        interest: '/interest',
        toggleInterest: '/toggle_interest',
        qsaForm: '/scholarships/award/form',
        send_email_notification: '/peluang-sbmptn/send-email-notification',
        paperplane: {
          campus_opts: '/peluang-sbmptn/campus_options',
          study_prog_opts: '/peluang-sbmptn/study_program_options',
          submit: '/peluang-sbmptn/submit_score',
        },
        darklaunch: {
          get: '/darklaunch',
        },
      }
    )
  }
}
